import { sort_center_api } from '@shared/api';

function cleanScannerCode(value: string): string {
  // eslint-disable-next-line no-control-regex
  return value.replace(/[\x00-\x1F\x7F]/g, '');
}

export async function getBagApiLabel(bagNumber: string): Promise<Blob> {
  const cleanBagNumber = cleanScannerCode(bagNumber);
  const url = `v1/bags/${encodeURIComponent(cleanBagNumber)}/api-label`;

  const response = await sort_center_api.get(url, {
    responseType: 'blob',
  });

  return new Blob([response.data], { type: 'application/pdf' });
}
